module.exports = __webpack_public_path__ + "images/花筑奢pr长图_01.jpg?v=c0db8218";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_01.jpg
 ** module id = 27
 ** module chunks = 1 2
 **/